// Build interactive Band and Cup swatches from variant option2 (e.g., "32 A")
document.addEventListener("DOMContentLoaded", function () {
  //  If URL contains query param variant, remove it to prevent size selection
  var url = new URL(window.location.href);
  if (url.searchParams.has("variant")) {
    url.searchParams.delete("variant");
    var newUrl = url.pathname + url.search + url.hash;
    window.history.replaceState({}, "", newUrl);
  }

  // Locate variants JSON embedded by the theme (only when dynamic options are enabled)
  const variantDataElement = document.querySelector("[data-variant-json]");
  if (!variantDataElement) return;

  // Parse product variants we will use to derive band/cup availability
  const variants = JSON.parse(variantDataElement.textContent);

  // Hide the original combined selector; our UI will mirror it underneath
  // Get the parent of the HTML element with data-product-option="option2"
  const option2Elem = document.querySelector('[data-product-option="option2"]');
  const originalWrapper = option2Elem ? option2Elem.parentElement : null;
  if (originalWrapper) originalWrapper.style.display = "none";

  // Clear the server-rendered default selection on the hidden size <select>.
  // Otherwise, when the user changes color before picking a size, ProductForm
  // would resolve a real variant (new color + default size) and incorrectly
  // enable the Add to Cart button (or trigger Klaviyo's Notify Me overlay).
  const option2Select = option2Elem
    ? option2Elem.querySelector("select")
    : null;
  if (option2Select) {
    option2Select.selectedIndex = -1;
  }

  // Container for product options where custom controls will be injected
  const container = document.querySelector(".product__variants-wrapper");
  if (!container) return;

  // Sets/mappings to compute availability from variants
  const bandSet = new Set();
  const cupSet = new Set();
  const bandToCups = {};
  const cupToBands = {};

  // Populate sets and cross-maps (band -> cups, cup -> bands) from variant option2
  variants.forEach((v) => {
    if (!v.option2) return;

    const parts = v.option2.trim().split(/\s+/);
    if (parts.length !== 2) return;

    const band = parts[0]; // numeric part, e.g., "32"
    const cup = parts[1].toUpperCase(); // letter part, e.g., "A"

    bandSet.add(band);
    cupSet.add(cup);

    bandToCups[band] = bandToCups[band] || new Set();
    bandToCups[band].add(cup);

    cupToBands[cup] = cupToBands[cup] || new Set();
    cupToBands[cup].add(band);
  });

  // Sort for predictable, user-friendly ordering
  const bandOptions = Array.from(bandSet).sort(
    (a, b) => parseInt(a) - parseInt(b),
  );
  const cupOptions = Array.from(cupSet).sort((a, b) => a.localeCompare(b));

  // Track current selections
  let selectedBand = "";
  let selectedCup = "";

  // Create a labeled swatch group for bands or cups
  function createSwatchGroup(label, options, type, isTopOption = false) {
    const wrapper = document.createElement("div");
    wrapper.className = "u2c-custom product__option";

    if (isTopOption) {
      wrapper.style.marginTop = "24px";
    }

    const labelWrapperEl = document.createElement("div");
    labelWrapperEl.className = "u2c-custom product__label-wrapper";
    const labelEl = document.createElement("div");
    labelEl.className = `u2c-custom product__label ${
      isTopOption ? "u2c_kiwi-anchor" : ""
    }`;
    labelEl.textContent = label;
    labelWrapperEl.appendChild(labelEl);

    const swatches = document.createElement("div");
    swatches.className = "u2c-custom product__color-swatches";
    swatches.dataset.type = type;

    options.forEach((opt) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "u2c-custom product__chip";
      btn.dataset.value = opt;
      btn.textContent = opt;
      swatches.appendChild(btn);
    });

    wrapper.appendChild(labelWrapperEl);
    wrapper.appendChild(swatches);
    return wrapper;
  }

  // Build and mount Band and Cup groups
  const bandGroup = createSwatchGroup("Band Size", bandOptions, "band", true);
  const cupGroup = createSwatchGroup("Cup Size", cupOptions, "cup");

  container.appendChild(bandGroup);
  container.appendChild(cupGroup);

  // Disable incompatible choices based on current counterpart selection
  function updateDisabledStates() {
    document
      .querySelectorAll('[data-type="cup"] .product__chip')
      .forEach((btn) => {
        const val = btn.dataset.value;
        const enabled = selectedBand && bandToCups[selectedBand]?.has(val);
        btn.classList.toggle("unavailable", selectedBand && !enabled);
      });

    document
      .querySelectorAll('[data-type="band"] .product__chip')
      .forEach((btn) => {
        const val = btn.dataset.value;
        const enabled = selectedCup && cupToBands[selectedCup]?.has(val);
        btn.classList.toggle("unavailable", selectedCup && !enabled);
      });
  }

  // Sync the hidden <button> so the rest of the theme reacts (cart, availability, etc.)
  function updateVariantSelection() {
    if (!selectedBand || !selectedCup) return;

    const combined = `${selectedBand} ${selectedCup}`;
    const originalSizeButton = document.querySelector(
      `[data-option-value="${combined}"]`,
    );

    if (originalSizeButton) {
      originalSizeButton.click();
    }
  }

  // Handle a click on a swatch: set selection, update UI, propagate change
  function handleSwatchClick(e) {
    if (
      !e.target.classList.contains("product__chip") ||
      e.target.classList.contains("unavailable")
    )
      return;

    const swatches = e.target.parentElement;
    const type = swatches.dataset.type;
    const value = e.target.dataset.value;

    [...swatches.children].forEach((btn) => btn.classList.remove("selected"));
    e.target.classList.add("selected");

    if (type === "band") {
      selectedBand = value;
    } else {
      selectedCup = value;
    }

    updateDisabledStates();
    updateVariantSelection();
  }

  // Delegate click handling within each swatch group
  document.querySelectorAll(".product__color-swatches").forEach((group) => {
    group.addEventListener("click", handleSwatchClick);
  });

  // Initialize UI based on the currently selected variant (if any)
  const currentVariant = variants.find(
    (v) => v.id === parseInt(container.dataset.currentVariantId),
  );
  if (currentVariant && currentVariant.option2) {
    const parts = currentVariant.option2.trim().split(/\s+/);

    if (parts.length === 2) {
      selectedBand = parts[0];
      selectedCup = parts[1].toUpperCase();

      document
        .querySelectorAll('[data-type="band"] .product__chip')
        .forEach((btn) => {
          if (btn.dataset.value === selectedBand) btn.classList.add("selected");
        });
      document
        .querySelectorAll('[data-type="cup"] .product__chip')
        .forEach((btn) => {
          if (btn.dataset.value === selectedCup) btn.classList.add("selected");
        });

      updateDisabledStates();
      updateVariantSelection();
    }
  }
});
